import { useCallback, useState, type DragEvent, type ChangeEvent } from "react";
import "./Uploader.css";

interface Props {
  onFiles: (files: File[]) => void;
  hint?: string;
}

export default function Uploader({ onFiles, hint }: Props) {
  const [hover, setHover] = useState(false);

  const handleDrop = useCallback(
    (e: DragEvent<HTMLLabelElement>) => {
      e.preventDefault();
      setHover(false);
      const files: File[] = [];
      if (e.dataTransfer.items) {
        for (const item of Array.from(e.dataTransfer.items)) {
          const f = item.getAsFile?.();
          if (f) files.push(f);
        }
      } else {
        for (const f of Array.from(e.dataTransfer.files)) files.push(f);
      }
      if (files.length) onFiles(files);
    },
    [onFiles]
  );

  const handleSelect = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (!e.target.files) return;
      onFiles(Array.from(e.target.files));
      // Allow re-selecting the same file again later.
      e.target.value = "";
    },
    [onFiles]
  );

  return (
    <label
      className={`uploader${hover ? " hover" : ""}`}
      onDragEnter={(e) => {
        e.preventDefault();
        setHover(true);
      }}
      onDragOver={(e) => e.preventDefault()}
      onDragLeave={() => setHover(false)}
      onDrop={handleDrop}
    >
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleSelect}
        hidden
      />
      <div className="uploader-inner">
        <div className="uploader-icon">📷</div>
        <strong>Drop pictures here</strong>
        <span className="muted">or tap to choose</span>
        {hint && <span className="muted hint">{hint}</span>}
      </div>
    </label>
  );
}
